






























































import Vue from 'vue'
import _ from 'lodash'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import ProjectAddressSearch from '@/components/master-data/address/ProjectAddressSearch.vue'
import { SAVE_ADDRESSES_PROJECT_ADDRESS, UPDATE_ADDRESSES_PROJECT_ADDRESS } from '@/store/action-types'
import { InsertProjectAddressRequestPayload, UpdateProjectAddressRequestPayload } from '@/types/payload'
import { AddressArt } from '@/model/addresses/AddressArt'
import { AddressDispCode } from '@/model/addresses/AddressDispCode'
import { AddressProjectAddress } from '@/model/addresses/AddressProjectAddress'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import { SaveUpdateDeleteProjectAddressResponse } from '@/types/service-response'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  inSaveProgress: boolean
  title: string
  validationRules: Array<Function>
  selectedArt: number | undefined
  selectedProcessStepType: number | undefined
  address: string
  selectedAddressId: number | undefined
  showSearchDialog: boolean
}

export default Vue.extend({
  name: 'ProjectAddressDialog',

  components: {
    ProjectAddressSearch
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    addressId:{
      type: Number,
      default: undefined
    },
    dialogData: Object as () => AddressProjectAddress | undefined,
    addressArtList: Array as () => AddressArt[],
    addressDispCodeList: Array as () => AddressDispCode[],
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      inSaveProgress: false,
      title: '',
      validationRules: [required],
      selectedArt: undefined,
      selectedProcessStepType: undefined,
      address: '',
      selectedAddressId: undefined,
      showSearchDialog: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    getAddressArtLabel (item: AddressArt): string {
      return item.bezeichnung // `${item.code} ${item.bezeichnung}`
    },

    onSearchAddressClick (): void {
      this.showSearchDialog = true
    },

    closeSearchDialog (): void {
      this.showSearchDialog = false
      setTimeout(() => {
        const saveButton: any = this.$refs['saveButton']
        if (saveButton) {
          saveButton.$el.focus()
        }
      }, 0)
    },

    onSelectedAddress (data: SearchAddress): void {
      this.showSearchDialog = false
      this.address = data.genAdresse
      this.selectedAddressId = data.id
      setTimeout(() => {
        const saveButton: any = this.$refs['saveButton']
        if (saveButton) {
          saveButton.$el.focus()
        }
      }, 0)
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate() && this.selectedAddressId) {
        if(!this.dialogData) {
          const payload: InsertProjectAddressRequestPayload = {
            AdressID: this.addressId,
            AdressArtenID: this.selectedArt!,
            MitAdressID: this.selectedAddressId!,
            WertID: this.selectedProcessStepType!,
            Sprache: this.selectedLanguageId
          }

          this.saveProjectAddress(payload)
        } else {
          const payload: UpdateProjectAddressRequestPayload = {
            AdressSchritteID: this.dialogData!.adressSchritteId,
            AdressID: this.addressId,
            AdressArtenID: this.selectedArt!,
            MitAdressID: this.selectedAddressId!,
            WertID: this.selectedProcessStepType!,
            Sprache: this.selectedLanguageId
          }

          this.updateProjectAddress(payload)
        }
      }
    },

    async saveProjectAddress (payload: InsertProjectAddressRequestPayload): Promise<void> {
      this.inSaveProgress = true
      try {
        let response: SaveUpdateDeleteProjectAddressResponse = await this.$store.dispatch(SAVE_ADDRESSES_PROJECT_ADDRESS, payload)
        if(response && !response.IsError) {
          this.$emit('dialogSaved')
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    },

    async updateProjectAddress (payload: UpdateProjectAddressRequestPayload): Promise<void> {
      this.inSaveProgress = true
      try {
        let response: SaveUpdateDeleteProjectAddressResponse = await this.$store.dispatch(UPDATE_ADDRESSES_PROJECT_ADDRESS, payload)
        if(response && !response.IsError) {
          this.$emit('dialogSaved')
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    }
  },

  mounted (): void {
    if(this.dialogData) {
      this.title = this.$t('masterData.addresses.projectAddress.editProjectAddressTitle').toString()
      const data: AddressProjectAddress = _.cloneDeep(this.dialogData)
      this.selectedArt = data.adressArtenId
      this.selectedProcessStepType = data.wertId
      this.address = data.genAdresse
      this.selectedAddressId = data.mitAdressId
    } else {
      this.title = this.$t('masterData.addresses.projectAddress.addProjectAddressTitle').toString()
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
